import { PatientEducationPage } from "./patientEducationPage";

export const PatientEducation = PatientEducationPage;
